module.exports = __webpack_public_path__ + "img/perfectiondetail_2@2x.fae9d07.webp";